
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#f0f0f0","d":"M341.334 85.33H0v341.332h512V85.33z"}}),_c('path',{attrs:{"fill":"#6da544","d":"M0 85.333h170.663V426.67H0z"}}),_c('path',{attrs:{"fill":"#d80027","d":"M341.337 85.333H512V426.67H341.337z"}})])
          )
        }
      }
    